import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 40px 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    padding: 60px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 60px 0;
  }
`;

export const CDIC = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  margin-bottom: 20px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0px;
    align-items: flex-start;
  }
`;

export const Content = styled.div`
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    text-align: left;
    max-width: 435px;
    padding-left: 45px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 670px;
    padding-left: 70px;
  }
`;

export const Body = styled.div``;

export const ImageWrapper = styled.div``;

export const Img = styled(Image)`
  width: 132px;
  height: 63px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 228px;
    height: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 327px;
    height: 157px;
  }
`;

export const StyledParagraph = styled.p`
  margin: 14px 0 18px;
  font-size: 14px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 16px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    font-size: 18px;
  }
`;

export const Ulist = styled.ul`
  text-align: left;
  margin: 14px 0 18px 14px;
  li {
    font-size: 10px;
    font-weight: ${themeGet('fontWeights.bold')};
    p {
      font-size: 14px;
      margin: 0;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      p {
        font-size: 16px;
      }
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 12px;
      p {
        font-size: 18px;
      }
    }
  }

  p {
    font-size: 18px;
    font-weight: ${themeGet('fontWeights.normal')};
  }
`;

export const Olist = styled.ol`
  text-align: left;
  margin: 14px 0 18px 14px;
  li {
    font-size: 10px;
    font-weight: ${themeGet('fontWeights.bold')};
    p {
      font-size: 14px;
      margin: 0;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      p {
        font-size: 16px;
      }
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 12px;
      p {
        font-size: 18px;
      }
    }
  }

  p {
    font-size: 18px;
    font-weight: ${themeGet('fontWeights.normal')};
  }
`;

export const StyledLink = styled(Link)`
  span {
    font-size: 14px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 16px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 18px;
    }
  }
`;
